import {
  __esm
} from "./chunk-ZU6LNBSF.mjs";

// src/utils/get-valid-children.ts
import { Children, isValidElement } from "react";
var getValidChildren;
var init_get_valid_children = __esm({
  "src/utils/get-valid-children.ts"() {
    getValidChildren = (children) => {
      return Children.toArray(children).filter(
        (child) => isValidElement(child)
      );
    };
  }
});

export {
  getValidChildren,
  init_get_valid_children
};
